import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loadingoverlay"
}
const _hoisted_2 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLoader',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  isFullPage: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "title",
          style: {"text-align":"center"}
        }, "Loading...", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
        _cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "subtitle",
          style: {"text-align":"center"}
        }, " Hang tight, this will just take a sec. ", -1)),
        _createElementVNode("img", {
          src: require('@/assets/images/loading.gif'),
          alt: "Loading"
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})